import { Link } from "react-router-dom";
import { Phone, MapPin } from "lucide-react";
import { SITE } from "@/data/site";
import { SERVICES } from "@/data/services";
import { LOCATIONS } from "@/data/locations";

const FooterLink = ({ to, children, testId }) => (
  <Link
    to={to}
    data-testid={testId}
    className="block py-1 text-sm text-slate-400 transition-colors hover:text-gold"
  >
    {children}
  </Link>
);

export const Footer = () => (
  <footer className="grain bg-navy-deep text-slate-300" data-testid="site-footer">
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div>
          <p className="font-display text-xl font-bold text-white">
            Travel Passport <span className="text-gold">&amp;</span> Visa
          </p>
          <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.3em] text-slate-500">
            LLC — Washington, DC
          </p>
          <div className="mt-6 space-y-3 text-sm">
            <a href={SITE.phoneTel} data-testid="footer-phone" className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-gold">
              <Phone className="h-4 w-4 text-gold" />
              {SITE.phoneDisplay}
            </a>
            <a href={SITE.phone2Tel} data-testid="footer-phone-2" className="flex items-center gap-2.5 text-slate-300 transition-colors hover:text-gold">
              <Phone className="h-4 w-4 text-gold" />
              {SITE.phone2Display}
            </a>
            <p className="flex items-start gap-2.5 text-slate-400" data-testid="footer-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
              <span>
                {SITE.addressLine1}
                <br />
                {SITE.addressLine2}
              </span>
            </p>
          </div>
          <p className="mt-6 inline-block rounded-full border border-gold/40 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] text-gold" data-testid="footer-private-badge">
            Private Service Provider
          </p>
        </div>
        <div>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold">Services</p>
          {SERVICES.slice(0, 7).map((s) => (
            <FooterLink key={s.slug} to={`/services/${s.slug}`} testId={`footer-service-${s.slug}`}>
              {s.name}
            </FooterLink>
          ))}
          <FooterLink to="/services" testId="footer-all-services">All Services</FooterLink>
        </div>
        <div>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold">Company</p>
          <FooterLink to="/" testId="footer-home">Home</FooterLink>
          <FooterLink to="/business" testId="footer-business">Business Services</FooterLink>
          <FooterLink to="/about" testId="footer-about">About</FooterLink>
          <FooterLink to="/faq" testId="footer-faq">FAQ</FooterLink>
          <FooterLink to="/contact" testId="footer-contact">Contact</FooterLink>
          <FooterLink to="/privacy-policy" testId="footer-privacy">Privacy Policy</FooterLink>
          <FooterLink to="/terms" testId="footer-terms">Terms</FooterLink>
        </div>
        <div>
          <p className="mb-4 font-display text-sm font-semibold uppercase tracking-[0.2em] text-gold">Service Areas</p>
          {LOCATIONS.slice(0, 7).map((l) => (
            <FooterLink key={l.slug} to={`/locations/${l.slug}`} testId={`footer-location-${l.slug}`}>
              {l.name}
            </FooterLink>
          ))}
          <FooterLink to="/locations" testId="footer-all-locations">All Service Areas</FooterLink>
        </div>
      </div>
      <div className="mt-14 border-t border-white/10 pt-8">
        <p className="mx-auto max-w-5xl text-center text-[11px] leading-relaxed text-slate-500" data-testid="footer-disclosure">
          {SITE.disclosure}
        </p>
        <p className="mt-6 text-center text-xs text-slate-500">
          © {new Date().getFullYear()} {SITE.name}. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
